import { syncTypeEnumList } from '../../../components/AgGrid/enumLists'

const syncListTypeValueGetter = (props) => {
  const { value } = props
  return syncTypeEnumList(value)
}

export default syncListTypeValueGetter
